module.exports = __webpack_public_path__ + "img/3988405.png";